import React, { useContext } from 'react'
import { Card, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import { faSignInAlt, faSpider } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import CpfComponent from '@component/Form/Cpf'
import InputComponent from '@component/Form/Input'
import ButtonComponent from '@component/Form/Button'

import { AclService } from '@service/acl'
import { AuthService } from '@service/auth'

import Swal from 'sweetalert2'

import logoLogin from '@public_images/logo-completo.png'


export default function Login() {

    const navigate = useNavigate();
    
    const { 
        control, 
        formState: { errors }, 
        handleSubmit, 
        register 
    } = useForm({ mode: 'onChange' })

    const onSubmit = async (data, e) => {
		e.preventDefault();

        Swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            imageUrl: '/assets/images/loading.gif',
            imageWidth: 100,
            imageHeight: 100,
            html: 'Processando, aguarde...',
            showConfirmButton: false,
            width: 300,
        });

        await AuthService.authenticate(data)
            .then(response => {
                AclService.setToken(JSON.stringify(response.data.token));
                AclService.setUser(JSON.stringify(response.data.user));
                Swal.close();
                navigate('/dashboard');
            })
            .catch(error => { 
                Swal.close();
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    icon: 'error',
                    html: error.response.data.message
                });
            });
    }


    return (
        <>

            <div className='text-center mt-4 mb-4'>
                <img src={ logoLogin } alt='Logo PMO' width='264' height='173' />
            </div>

            <Card>
                <Card.Body>
                    <div className='m-sm-3'>

                        <Form 
                            autoComplete='off'
                            onSubmit={handleSubmit(onSubmit)}>
                        
                            <CpfComponent
                                control={control}
                                errors={errors}
                                label='CPF'
                                name='cpf'
                                register={register}
                            />

                            <InputComponent
                                control={control}
                                errors={errors}
                                label='Senha'
                                name='password'
                                placeholder='Informe sua senha' 
                                type='password'
                                register={register}
                            />

                            {/* <small><a href='/pages-reset-password'>Esqueceu sua senha?</a></small> */}

                            <div className='text-center mt-3'>
                                <ButtonComponent
                                    icon={faSignInAlt}
                                    id='btn-login'
                                    title='Entrar'
                                />
                            </div>
                        </Form>

                    </div>
                </Card.Body>
            </Card>

        </>
    )
}
